import React from 'react';
import { IMtuPlanFeatureFragment } from '../../../../utils/apollo/graphqlSchema';
import * as PlanFeaturesUI from './PlanFeaturesUI';

interface IProps {
  features: IMtuPlanFeatureFragment[];
  title: string;
  icon: React.ReactElement;
}

const PlanFeatures = ({ features, title, icon }: IProps) => {
  return (
    <PlanFeaturesUI.Container>
      <PlanFeaturesUI.Title>{title}</PlanFeaturesUI.Title>
      <PlanFeaturesUI.List>
        {features.map((item, index) => (
          <PlanFeaturesUI.ListItem key={index}>
            {icon}
            <div>
              <PlanFeaturesUI.ItemText $isNode={!!item.subFeatures?.length}>
                {item.display}
              </PlanFeaturesUI.ItemText>
              {item.subFeatures.length > 0 && (
                <PlanFeaturesUI.SubList>
                  {item.subFeatures.map((subItem, subIndex) => (
                    <PlanFeaturesUI.SubListItem key={subIndex}>
                      {subItem}
                    </PlanFeaturesUI.SubListItem>
                  ))}
                </PlanFeaturesUI.SubList>
              )}
            </div>
          </PlanFeaturesUI.ListItem>
        ))}
      </PlanFeaturesUI.List>
    </PlanFeaturesUI.Container>
  );
};

export default PlanFeatures;
